<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z"
      stroke="#000"
    />
    <path
      d="M56 30C56 44.3594 44.3594 56 30 56C15.6406 56 4 44.3594 4 30C4 15.6406 15.6406 4 30 4C44.3594 4 56 15.6406 56 30Z"
      :stroke="clr ? clr : '#56606B'"
    />
  </svg>
</template>
